import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.73 11.46L12 2L8.27 11.46L2.11 6.43L2 6.34L4.73 21.96V22H19.25L21.97 6.47L21.99 6.34L15.72 11.46H15.73ZM5 11.4L10.4 15.81L6.35 19.12L5 11.4ZM15.57 20.02H8.45L12.01 17.11L15.57 20.02ZM12.01 7.65L15.99 17.75L9.97 12.83L12.01 7.64V7.65ZM16.52 13.44L19.02 11.4L18 17.2L16.52 13.44Z" fill={ fill || 'currentColor' } />
    </svg>
);
